import { Dayjs } from 'dayjs';
import { ReactNode } from 'react';
import { Control, FieldError, FieldValues } from 'react-hook-form';

import 'react-datepicker/dist/react-datepicker.css';

import DateInputView from './DateInputView';
import DateInputWithControllerView from './DateInputWithControllerView';

export interface IProps {
  name?: string;
  control?: Control<FieldValues, object>;
  required?: boolean;
  label?: string;
  tooltip?: string;
  onKeyDown?: (event) => void;
  minDate?: Dayjs;
  maxDate?: Dayjs;
  dateFormat?: string;
  error?: FieldError;
  disabled?: boolean;
  isClearable?: boolean;
  placeholder?: string;
  endDecorator?: ReactNode;
  onChange?: (value: Dayjs | null) => void;
  popperProps?: Record<string, unknown>;
}

const DateInput = (props: IProps) => {
  if (props.control) {
    return <DateInputWithControllerView {...props} />;
  }

  return <DateInputView {...props} />;
};

export default DateInput;
